import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useParams, useHistory} from "react-router-dom";
import {MenuItem, TextField, Select, InputLabel, FormControl, Button} from "@material-ui/core";
import {Editor} from "@tinymce/tinymce-react/lib/cjs/main/ts";
import {ServerApi} from "../ServerApi";
import {Actions} from "../store/Actions";
import {DictionaryGroup} from "../models/models";
import "./WordEditorComponent.scss"
import Axios from "axios";



export const WordEditorComponent: React.FC<any> = () => {
	const history = useHistory();
	const dispatch = useDispatch();


	const {wordIdParam} = useParams();
	const [dictionaryGroups, setDictionaryGroups] = useState<DictionaryGroup[]>([]);
	const [wordId, setWordId] = useState<number | null>(null);
	const [dictionaryId, setDictionaryId] = useState<number>(-1);
	const [term, setTerm] = useState("");
	const [description, setDescription] = useState("");
	const [version, setVersion] = useState<number | null>(null);


	useEffect(() => {
		ServerApi
			.getDictionaryGroups()
			.then(dgs => setDictionaryGroups(dgs));

		if (wordIdParam) {
			ServerApi
				.getWord(Number(wordIdParam))
				.then(word => {
					setWordId(word!.id);
					setDictionaryId(word!.dictionaryId);
					setTerm(word!.term);
					setDescription(word!.description);
					setVersion(word!.version);
				});
		}

		return () => {
			setWordId(null);
			setDictionaryId(-1);
			setTerm("");
			setDescription("");
			setVersion(null);
		};

	}, [wordIdParam]);


	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (wordIdParam) {
			ServerApi
				.updateWord(wordId!, version!, dictionaryId!, term, description)
				.then(w => {
					dispatch(Actions.updateIndexWordAction({id: w.id, term: w.term, updatedWhen: w.updatedWhen, deleteChecked: false}));
					history.push(`/${w.id}`)
				});
		} else {
			ServerApi
				.createWord(dictionaryId, term, description)
				.then(w => {
					dispatch(Actions.addIndexWordAction({id: w.id, term: w.term, updatedWhen: w.updatedWhen, deleteChecked: false}));
					history.push(`/${w.id}`)
				});
		}
	};


	return (
		<>
			<form onSubmit={handleSubmit}>
				<div className="flex-box">
					<FormControl variant="outlined" style={{width: "200px"}}>
						<InputLabel id="demo-simple-select-outlined-label">사전</InputLabel>
						<Select value={dictionaryId}
						        labelId="demo-simple-select-outlined-label"
						        onChange={(e) => setDictionaryId(parseInt(e.target.value as string))}
						        variant="outlined"
						        label="사전">
							{dictionaryGroups
								.flatMap(dg => dg.dictionaries)
								.map(d =>
									<MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
								)
							}
						</Select>
					</FormControl>

					<TextField className="term-input"
					           label="용어를 입력해주세요."
					           style={{width: "400px"}}
					           value={term}
					           variant="outlined"
					           onChange={(e) => setTerm(e.target.value)}/>
				</div>

				<br/>

				<Editor
					apiKey="t1gn1f1pvyds9urftqw5t780j433ar159v9bm81pb8h3wuqd"
					init={{
						language: 'ko_KR',
						height: 500,
						menubar: true,
						image_description: false,
						plugins: [
							'advlist autolink lists link image charmap print preview anchor',
							'searchreplace visualblocks code fullscreen',
							'insertdatetime media table paste code help wordcount charmap'
						],
						toolbar:
						// eslint-disable-next-line no-multi-str
							'\
							undo redo | bold italic forecolor backcolor | \
							alignleft aligncenter alignright |\
							numlist bullist charmap image ascending descending\
							',
						setup: (editor: any) => {

							editor.ui.registry.addButton('ascending', {
								text: '오름차순',
								onAction: () => {
									let foo = editor.selection.getContent().split('\n')
										.map((line: string) => new DOMParser().parseFromString(line, "text/html"))
										.sort(((a1: Document, a2: Document) => a1.body.innerText.localeCompare(a2.body.innerText)))
										.map((l: Document) => l.body.innerHTML);

									editor.selection.setContent(foo.join("\n"));
								},
							});

							editor.ui.registry.addButton('descending', {
								text: '내림차순',
								onAction: () => {
									let foo = editor.selection.getContent().split('\n')
										.map((line: string) => new DOMParser().parseFromString(line, "text/html"))
										.sort(((a1: Document, a2: Document) => -a1.body.innerText.localeCompare(a2.body.innerText)))
										.map((l: Document) => l.body.innerHTML);

									editor.selection.setContent(foo.join("\n"));
								},
							});
						},
						charmap: [
							[0x0007, '검은 원'],
							[0x25FC, '검은 네모'],
							[0x2605, '검은 별'],
							[0x2606, '빈 별'],
							[0x25C0, '검은 왼쪽 세모'],
							[0x25B6, '검은 오른쪽 세모'],
							[0x25B2, '검은 위쪽 세모'],
							[0x25BC, '검은 아랫쪽 세모'],
							[0x261A, '검은 왼 손가락'],
							[0x261B, '검은 오른 손가락'],
						],
						images_upload_handler: function (blobInfo: any, success: any, failure: any, progress: any) {
							const file = blobInfo.blob();

							const formData = new FormData();
							formData.append('file', file, file.name);

							Axios.post('/Api/Word/UploadWordImage', formData)
								.then(res => {
									success(res.data);
								})
								.catch(err => {
									failure('이미지 업로드 실패 : ' + err.message);
								});
						}
					}}
					value={description}
					onEditorChange={(content, editor) => setDescription(content)}
				/>

				<Button className="submit-button" type="submit" variant="contained" size="large" color="primary">제출</Button>
			</form>
		</>
	)
};